import {
  SelectionColumn,
  SelectionItem,
} from "../../shared/components/SelectionColumn";
import { BilletGroup, Location, SpecialLocation } from "../../../../models";
import {
  getAvailablePositions,
  isNextAvailablePosition,
} from "../../../../utils";

export interface PositionColumnProps {
  currentGroups: BilletGroup[];
  currentLocation: Location | SpecialLocation | null;
  selectedPositions: string[];
  onPositionChange: (value: string) => void;
  allowMultipleSelection?: boolean;
  customWidth?: string;
}

export const PositionColumn = ({
  currentGroups,
  currentLocation,
  selectedPositions,
  onPositionChange,
  allowMultipleSelection = false,
  customWidth,
}: PositionColumnProps) => {
  // Convert positions to SelectionItem format
  const availablePositions = getAvailablePositions(
    currentGroups,
    currentLocation?.AddFillingType,
  );

  const positionItems: SelectionItem[] = availablePositions.map((position) => {
    const isNextAvailable = isNextAvailablePosition(
      position,
      currentGroups,
      currentLocation?.AddFillingType,
    );

    // Display positions starting from 1 (like old system), but keep 0-based values for database
    const displayPosition = position + 1;

    return {
      Value: position.toString(), // Keep 0-based value for database operations
      Title: isNextAvailable
        ? `${displayPosition} (Next)`
        : displayPosition.toString(), // Display 1-based
    };
  });

  return (
    <SelectionColumn
      title="Position"
      data={positionItems}
      selectedItems={selectedPositions}
      onSelectionChange={onPositionChange}
      valueField="Value"
      titleField="Title"
      layoutMode="dynamic"
      isNarrowColumn={false}
      showTitleDivider={false}
      allowMultipleSelection={allowMultipleSelection}
      customWidth={customWidth}
    />
  );
};
